export const environment = {
  apiUrl: 'https://endkundenrechner-api.cpit.dev',
  enableTestDataViewer: true,
  allowBrandingQueryParam: false,
};
